// useSavedColumns.js
import { useEffect } from 'react';

export const useSavedColumns = (leadType, selectedColumns) => {
    // Save columns to localStorage
    useEffect(() => {
        if (leadType && selectedColumns) {
            const savedColumns = JSON.parse(localStorage.getItem('savedColumns')) || {};
            savedColumns[leadType] = selectedColumns;
            localStorage.setItem('savedColumns', JSON.stringify(savedColumns));
        }
    }, [leadType, selectedColumns]);

    // Clear localStorage (optional) → Only clears savedColumns
    useEffect(() => {
        const clearSavedColumns = () => {
            localStorage.removeItem('savedColumns');
        };
        window.addEventListener('beforeunload', clearSavedColumns);

        return () => {
            window.removeEventListener('beforeunload', clearSavedColumns);
        };
    }, []);

    // Helper to retrieve saved columns for a leadType
    const getSavedColumns = () => {
        const savedColumns = JSON.parse(localStorage.getItem('savedColumns')) || {};
        return savedColumns[leadType] || [];
    };

    return { getSavedColumns };
};
